import React, { useState } from "react";
import Slider from "react-slick";
import "./NewPropertySingle.css";


const tabs = [
    "Overview",
    "Society",
    "Dealer Details",
    "Price Trends",
    "Explore Locality",
    "Recommendations",
];

const galleryImages = [
    "https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1484154218962-a197022b5858?q=80&w=1200&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1200&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=1200&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1200&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=1200&auto=format&fit=crop",
];

const PropertyPageBanner = () => {
    const [activeTab, setActiveTab] = useState("Overview");
    const [showGallery, setShowGallery] = useState(false);

    const gallerySettings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
    };
    return (
        <section className="spb-main-wrapper">
            {/* <div className="home2-green-light"></div> */}
            <div className="home2-orange-light"></div>
            <div className="spb-topbar">
                <div className="spb-breadcrumb">
                    Home / Kolkata / New Town / <span>SEZH GROUP</span>
                </div>

                <div className="spb-update">
                    Last updated: Apr 7, 2026
                    <i className="fa-solid fa-circle-info"></i>
                </div>
            </div>

            <div className="spb-header-section">
                <div className="spb-header-left">
                    <h1>Property area Yard 123</h1>

                    <p className="spb-builder">
                        By <span>SEZH GROUP</span>
                    </p>

                    <p className="spb-location">
                        <i className="fa-solid fa-location-dot"></i>
                        New Town, Kolkata
                    </p>
                </div>

                <div className="spb-header-right">
                    <h2>₹75.83 L - 1.61 Cr</h2>

                    <p className="spb-price-line">₹7.1 K/sq.ft</p>

                    <p className="spb-emi">
                        EMI starts at <span>₹37.65 K</span>
                    </p>

                    <button className="spb-contact-btn">
                        <i className="fa-solid fa-phone"></i>
                        Contact Developer
                    </button>
                </div>
            </div>

            <div className="spb-gallery-wrapper">
                <div className="spb-main-image-box">
                    <img
                        src="https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=1400&auto=format&fit=crop"
                        alt="property"
                    />

                    {/* <div className="spb-image-tag">Cover Image</div> */}

                    <div className="spb-image-actions">
                        <button>
                            <i className="fa-solid fa-share-nodes"></i>
                            Share
                        </button>

                        <button>
                            <i className="fa-regular fa-heart"></i>
                            Save
                        </button>
                    </div>
                </div>

                <div className="spb-side-gallery">
                    <div className="spb-side-image">
                        <img
                            src="https://images.unsplash.com/photo-1484154218962-a197022b5858?q=80&w=1200&auto=format&fit=crop"
                            alt=""
                        />
                    </div>

                    <div
                        className="spb-side-image spb-more-image"
                        onClick={() => setShowGallery(true)}
                    >
                        <img
                            src="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1200&auto=format&fit=crop"
                            alt=""
                        />

                        <div className="spb-more-overlay">
                            <h3>22+</h3>
                            <p>more</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="spb-bottom-info">
                <div className="spb-info-card">
                    <h4>2, 3, 4 BHK Apartments</h4>
                    <p>Configurations</p>
                </div>

                <div className="spb-info-card">
                    <h4>Dec, 2029</h4>
                    <p>Possession Starts</p>
                </div>

                <div className="spb-info-card">
                    <h4>₹7.1K/sq.ft</h4>
                    <p>Avg. Price</p>
                </div>

                <div className="spb-info-card">
                    <h4>1068 - 2271 sq.ft</h4>
                    <p>Sizes</p>
                </div>
            </div>
            {/* <div className="property-tabs_n">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={`tab-item ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div> */}

            {
                showGallery && (
                    <div
                        className="spb-gallery-modal"
                        onClick={() => setShowGallery(false)}
                    >

                        <div
                            className="spb-gallery-modal-content"
                            onClick={(e) => e.stopPropagation()}
                        >

                            <button
                                className="spb-gallery-close"
                                onClick={() => setShowGallery(false)}
                            >
                                ×
                            </button>

                            <Slider {...gallerySettings}>

                                {galleryImages.map((img, index) => (
                                    <div
                                        className="spb-gallery-slide"
                                        key={index}
                                    >

                                        <img
                                            src={img}
                                            alt=""
                                        />

                                    </div>
                                ))}

                            </Slider>

                        </div>

                    </div>
                )
            }
        </section>
    );
};

export default PropertyPageBanner;